import { StyleSheet } from 'react-native';

import { primitive } from 'styles/constants/primitives';

export const commonStyles = StyleSheet.create({
  cartEntryBody: {
    fontSize: 14,
    fontFamily: primitive.fontFamily.$body,
    color: primitive.bk.$bbqBrown,
  },
  cartEntryItemName: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.bk.$bbqBrown,
  },
  withBorderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: primitive.$blackOpacity10,
  },
});
